<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '尿素费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <section slot="car" slot-scope="prop">
          <ChooseCar :isRadio="true" v-model="prop.form.car" @change="handleCarChange" />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '产品类型',
            value: 'ureaType',
            type: 'radio',
            placeholder: '请选择产品类型',
            default: '1',
            onChange: () => {
              this.handleUreaTypeChange();
            },
            options: [
              {
                label: '桶装',
                value: '1',
              },
              {
                label: '散装',
                value: '2',
              },
            ],
          },
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '规格',
            value: 'ureaSpecifications',
            type: 'input',
            placeholder: '请输入规格',
            hide: false,
          },
          {
            label: '数量',
            value: 'ureaCount',
            type: 'input',
            placeholder: '请输入数量',
            onInput: () => {
              this.handlePayAmt();
            },
          },
          {
            label: '单价',
            value: 'ureaPriceStr',
            type: 'input',
            placeholder: '请输入单价',
            onInput: () => {
              this.handlePayAmt();
            },
          },
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入申请金额',
            disabled: true,
          },
          // {
          //   label: '上传附件',
          //   value: 'detailPic',
          //   type: 'img',
          //   accept: 'image/*',
          //   fileSize: 5120,
          //   default: [],
          // },
        ],
        rules: { // 表单验证规则
          ureaType: [ // 产品类型
            { required: true, message: '请选择产品类型', trigger: 'blur' },
          ],
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          ureaSpecifications: [ // 规格
            { required: true, message: '请输入规格', trigger: 'blur' },
          ],
          ureaCount: [ // 数量
            { required: true, message: '请输入数量', trigger: 'blur' },
          ],
          ureaPriceStr: [ // 单价
            { required: true, message: '请输入单价', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handlePayAmt () {
      const ureaCount = this.$refs.customForm.getVal('ureaCount');
      const ureaPriceStr = this.$refs.customForm.getVal('ureaPriceStr');
      const payAmt = ureaCount * ureaPriceStr;
      if (!isNaN(payAmt)) {
        this.$refs.customForm.setVal('payAmt', Number(payAmt));
      }
    },
    handleCarChange (item) {
      const car = this.$refs.customForm.getVal('car');
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    handleUreaTypeChange () {
      const ureaType = this.$refs.customForm.getVal('ureaType');
      console.log(ureaType);
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: String(ureaType) === '2',
        names: ['ureaSpecifications'],
      });
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
          this.handleUreaTypeChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      delete form.car;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
